(() => {
  if (customElements.get('support-product-selector')) return;
  class SupportProductSelector extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const fallback = this.querySelector('[data-support-fallback]');
      const models = this.querySelector('[data-support-models]');
      const cards = this.querySelector('[data-support-cards]');
      const colour = this.querySelector('[data-support-colour]');
      const variants = this.querySelector('[data-support-variants]');
      const groupId = fallback.querySelector('select').id;
      const prefix = this.dataset.prefix;
      let products;
      try {
        products = JSON.parse(this.querySelector('[data-support-catalog]').textContent).products
          .filter(p => p.id && p.name && Array.isArray(p.variants) && p.variants.length && p.variants.every(v => v.id && v.sku && v.colour))
          .sort((a, b) => a.order - b.order);
      } catch { return; } // Keep the server-rendered selector if enhancement fails.
      if (!products.length) { this.querySelector('[data-support-unavailable]').hidden = false; return; }
      const fields = {};
      for (const key of ['product', 'productId', 'variant', 'sku', 'colour']) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = this.dataset[`${key}Name`];
        this.append(input);
        fields[key] = input;
      }
      const clear = () => Object.values(fields).forEach(input => { input.value = ''; });
      let current;
      const update = selected => {
        clear();
        const variant = current?.variants.find(v => String(v.id) === String(selected?.id));
        if (!variant) return;
        fields.product.value = `${current.name} - ${variant.colour}`;
        fields.productId.value = current.id;
        fields.variant.value = variant.id;
        fields.sku.value = variant.sku;
        fields.colour.value = variant.colour;
      };
      const makeCard = (name, source, value, group, small = false) => {
        const card = document.createElement('label');
        card.className = `${prefix}__card ${prefix}__product${small ? ' support-products__variant' : ''}`;
        const radio = document.createElement('input');
        radio.type = 'radio'; radio.name = `${groupId}-${group}`; radio.value = value; radio.required = true;
        radio.className = `${prefix}__card-input`;
        card.append(radio);
        let imageUrl;
        try {
          const url = new URL(source, location.origin);
          if (url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || ((url.origin === location.origin || ['sonicdental.co', 'uk.sonicdental.co', 'eu.sonicdental.co', 'sonicdental2022.myshopify.com'].includes(url.hostname)) && url.pathname.startsWith('/cdn/shop/')))) imageUrl = url.href;
        } catch { /* Invalid optional image must not block product selection. */ }
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl; image.alt = ''; image.width = small ? 88 : 132; image.height = small ? 66 : 98;
          image.loading = 'lazy'; image.className = `${prefix}__product-image`; card.append(image);
        }
        const title = document.createElement('span');
        title.className = `${prefix}__product-title`; title.textContent = name; card.append(title);
        return { card, radio };
      };
      for (const product of products) {
        const { card, radio } = makeCard(product.name, product.image || product.variants.find(v => v.image)?.image, product.id, 'model');
        radio.addEventListener('change', () => {
          current = product;
          variants.replaceChildren();
          colour.hidden = product.variants.length === 1;
          update(product.variants.length === 1 ? product.variants[0] : null);
          if (!colour.hidden) for (const variant of product.variants) {
            const option = makeCard(variant.colour, variant.image || product.image, variant.id, 'colour', true);
            option.radio.addEventListener('change', () => update(variant));
            variants.append(option.card);
          }
        });
        cards.append(card);
      }
      this.closest('form').addEventListener('reset', () => {
        current = undefined; clear(); variants.replaceChildren(); colour.hidden = true;
      });
      fallback.querySelector('select').disabled = true;
      fallback.hidden = true; models.hidden = false;
    }
  }
  customElements.define('support-product-selector', SupportProductSelector);
})();
